import Amplitude from 'amplitude-js'
import { AmplitudeApiKey } from '../private/private';

export var amplitude = Amplitude.getInstance();
amplitude.init(AmplitudeApiKey);